import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useUser } from "../../../pages/authentification/UserContext";
import { API_ENDPOINTS } from "../../../../ApiService";
import apiService from "../../../../ApiService";
import { Box, useTheme, Typography, Button } from "@mui/material";
import styled from "styled-components";
import TimeSeriesMensurationChart from "./TimeSeriesMensurationChart";

const Section = styled.section`
  width: 100%;
  height: 100%;
  padding: 4rem 0rem;
`;

const MensurationGraph = () => {
  const { clientID } = useParams();
  const { user } = useUser();
  const navigate = useNavigate();
  const [mensurations, setMensurations] = useState([]);
  const [hasData, setHasData] = useState(false);

  useEffect(() => {
    const fetchMensurationsData = async () => {
      try {
        const response = await apiService.get(
          API_ENDPOINTS.CLIENT_MENSURATIONS(clientID)
        );
        const data = response.data;
        console.log("Mensuration data", data);
        setMensurations(data);
        setHasData(data.length > 0);
      } catch (error) {
        console.error("Error fetching mensurations data:", error);
      }
    };

    if (clientID) {
      fetchMensurationsData();
    }
  }, [clientID]);

  if (!hasData) {
    return (
      <Section>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          p={4}
          bgcolor="lightgrey"
          borderRadius="8px"
          boxShadow={2}
        >
          <Typography variant="h6" color="textPrimary">
            Aucune donnée disponible pour le moment.
          </Typography>
          <Typography variant="body1" color="textSecondary" mt={1}>
            Quand tu commenceras à ajouter des valeurs, elles apparaitront ici.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={() => navigate(`/mensurationupdate/${clientID}`)}
          >
            Ajouter des mensurations
          </Button>
        </Box>
      </Section>
    );
  }

  return (
    <Section>
      <TimeSeriesMensurationChart rawData={mensurations} />
    </Section>
  );
};

export default MensurationGraph;
